import { render, staticRenderFns } from "./StageValidation.vue?vue&type=template&id=08fc42a0"
import script from "./StageValidation.vue?vue&type=script&lang=js"
export * from "./StageValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports